import { invalidateItemQueries } from '@/shared/api/invalidate-item-queries';
import { trpc } from '@/shared/api/trpc';

export const useUpdatePriorityLevel = () => {
  const utils = trpc.useUtils();
  return trpc.operations.updatePriorityLevel.useMutation({
    onSettled: () => invalidateItemQueries(utils),
  });
};
